import { userManagementConstant } from '../_constants';

export default function userManagement(state = {}, action) {
  switch (action.type) {

    //get
    case userManagementConstant.GET_USER_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getUserList: action?.user
      };
    case userManagementConstant.GET_USER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };


    case userManagementConstant.GET_USER_DETAILS_BY_ID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_USER_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        getUserDetailsById: action?.user?.data
      };
    case userManagementConstant.GET_USER_DETAILS_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };




    case userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        getMerchantKycDetailsById: action?.user?.data
      };
    case userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        getMerchantKycDetailsById: {}
      };







    case userManagementConstant.GET_SWAP_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_SWAP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getSwapListData: action?.user?.data
      };
    case userManagementConstant.GET_SWAP_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };



    case userManagementConstant.GET_ORDER_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_ORDER_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getP2POrderHistoryList: action?.user?.data
      };
    case userManagementConstant.GET_ORDER_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };




    case userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getBuyPkrdHistory: action?.user?.data
      };
    case userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };


    case userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getBuyPkrdHistoryExpressCheckout: action?.user?.data
      };
    case userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };






    case userManagementConstant.GET_WEB_STORE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_WEB_STORE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getWebStoreData: action?.user?.data
      };
    case userManagementConstant.GET_WEB_STORE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };



    case userManagementConstant.GET_LOGIN_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_LOGIN_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getLoginHistoryListData: action?.user?.data?.list,
        getLoginHistoryListTotal: action?.user?.data?.total

      };
    case userManagementConstant.GET_LOGIN_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };




    case userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getMerchantWebStoreChargeList: action?.user?.data?.list,
        getMerchantWebStoreChargeTotal: action?.user?.data?.total

      };
    case userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };







    case userManagementConstant.GET_MERCHANT_API_KEY_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.GET_MERCHANT_API_KEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getMerchantApiKeyList: action?.user?.data?.list,
        merchantApiKeyTotal: action?.user?.data?.total,
        activeTotal: action?.user?.data?.activeTotal,
        disableTotal: action?.user?.data?.disableTotal

      };
    case userManagementConstant.GET_MERCHANT_API_KEY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };














    //update status
    case userManagementConstant.UPDATE_USER_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userManagementConstant.UPDATE_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action?.user
      };
    case userManagementConstant.UPDATE_USER_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };


    //get country code list
    case userManagementConstant.GET_COUNTRY_CODE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userManagementConstant.GET_COUNTRY_CODE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getCountry: action?.user?.data,
      };
    case userManagementConstant.GET_COUNTRY_CODE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case userManagementConstant.GET_USER_BANK_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userManagementConstant.GET_USER_BANK_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getUserBankDetails: action?.user?.data,
      };
    case userManagementConstant.GET_USER_BANK_DETAILS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };





    case userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_SUCCESS:
      return {
        ...state,
        loading: false,
        getUserTransactionList: action?.user?.data,
      };
    case userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };




    case userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        getRedeemRequestListExpress: action?.user?.data,
        getRedeemRequestExpTotal: action?.user?.data?.total,

      };
    case userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };




    case userManagementConstant.GET_REDEEM_REQUEST_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userManagementConstant.GET_REDEEM_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getRedeemRequestList: action?.user?.data,
        getRedeemRequestTotalInd: action?.user?.data?.total,

      };
    case userManagementConstant.GET_REDEEM_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state
  }
}